// Shared UI theme: minimal, slick, black-&-white. One injected stylesheet drives every
// overlay via `--gl-*` custom properties. We keep it understated — a clean sans face, a
// near-black canvas, hairline borders, white as the single accent — rather than loud pixel
// chrome. (The game world itself stays pixel-art; this is just the 2D UI layer.)

const THEME_ID = "ghostland-theme-vars";

const VARS = `
:root {
  --gl-bg: #000;
  --gl-bg-gradient: #000;
  --gl-panel: #0a0a0a;        /* near-black surface */
  --gl-panel-2: #050505;      /* inset / fields */
  --gl-border: #262626;       /* hairline border */
  --gl-border-focus: #5a5a5a;
  --gl-accent: #f5f5f5;        /* the lone accent: white */
  --gl-accent-hover: #ffffff;
  --gl-accent-fg: #000000;     /* text on a white fill */
  --gl-text: #f2f2f2;
  --gl-muted: #767676;
  --gl-error: #ff5c5c;         /* errors only */
  --gl-selected: #ffffff;
  --gl-font: -apple-system, BlinkMacSystemFont, "Segoe UI", Inter, system-ui, sans-serif;
}

/* Gentle, global: one clean face + crisp antialiasing. Nothing chunky — components keep
   their own spacing, borders and radii so each overlay stays minimal + slick. */
[id^="gl-"], [class^="gl-"], [class*=" gl-"], [id^="gl-"] * {
  font-family: var(--gl-font) !important;
  -webkit-font-smoothing: antialiased;
}
[id^="gl-"] input, [id^="gl-"] select { font-family: var(--gl-font) !important; }
`;

export function injectTheme(): void {
  const existing = document.getElementById(THEME_ID) as HTMLStyleElement | null;
  if (existing) {
    if (existing.textContent !== VARS) existing.textContent = VARS; // refresh on hot-reload
    return;
  }
  const style = document.createElement("style");
  style.id = THEME_ID;
  style.textContent = VARS;
  document.head.appendChild(style);
}
